import { useEffect, useState } from "react";
import { MessageCircle, Users } from "lucide-react";
import axios, { API } from "@/lib/api";
import StatusBadge from "@/components/shared/StatusBadge";
import LoadingScreen from "@/components/shared/LoadingScreen";
import EmptyState from "@/components/shared/EmptyState";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function GuideJamaah() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    axios.get(`${API}/guide/jamaah`).then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, []);

  if (items === null) return <LoadingScreen />;

  return (
    <div data-testid="guide-jamaah-page" className="space-y-6">
      <div>
        <h1 className="font-heading text-2xl font-bold text-[#1F2937]">Jamaah Saya</h1>
        <p className="text-sm text-[#64748B]">Daftar jamaah yang berada dalam bimbingan Anda.</p>
      </div>

      {items.length === 0 ? (
        <EmptyState icon={Users} title="Belum ada jamaah ditugaskan" description="Jamaah akan muncul setelah ditempatkan pada program Anda." />
      ) : (
        <div className="overflow-x-auto rounded-xl border border-slate-100 bg-white">
          <Table data-testid="guide-jamaah-table">
            <TableHeader><TableRow><TableHead>Nama</TableHead><TableHead>Kota</TableHead><TableHead>Status</TableHead><TableHead className="text-right">Aksi</TableHead></TableRow></TableHeader>
            <TableBody>
              {items.map((j) => (
                <TableRow key={j.id} data-testid={`guide-jamaah-row-${j.id}`}>
                  <TableCell className="font-medium text-[#1F2937]">{j.name}</TableCell>
                  <TableCell className="text-[#64748B]">{j.city}</TableCell>
                  <TableCell><StatusBadge status={j.status} /></TableCell>
                  <TableCell className="text-right">
                    <a href={`https://wa.me/${j.phone?.replace(/^0/, "62")}`} target="_blank" rel="noreferrer" data-testid={`guide-contact-jamaah-${j.id}`} className="inline-flex items-center gap-1 text-sm font-medium text-[#0F6B4F] hover:underline">
                      <MessageCircle className="h-3.5 w-3.5" /> Hubungi
                    </a>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}
    </div>
  );
}
